import store from "../../store";
import lookup from "./lookup";
import metricsService from "./metrics-service";

const MainPlugin = {
    install(Vue, options) {
      Vue.mixin({
        created() {
            this.can = store.state.permissions;
            this.$_parentsByProperty = {};
        },
        destroyed() {
        },
        mounted() {
            if(this.amfOptions && this.amfOptions.metrics)
                metricsService.start('component', this);
        },
        beforeDestroy()  {
            if(this.amfOptions && this.amfOptions.metrics)
                metricsService.stop('component', this);
        },
        methods: {
            refreshPermissions() {
                store.dispatch("permissions/refresh");
            },
            lookup,
            getParentProperty(prop, defaultValue) {
                if (this.$_parentsByProperty[prop] === undefined) {
                    this.$_parentsByProperty[prop] = findParentWithProperty(this.$parent, prop) || null;
                }
                if (this.$_parentsByProperty[prop]) {
                    return this.$_parentsByProperty[prop][prop];
                } else {
                    return defaultValue;
                }
            },
            isFeatureEnabled(feature) {
                var features = store.state.session.features;
                return features && features.includes(feature);
            }
        }
      });
    }
  };

  export default MainPlugin;

  function findParentWithProperty(parent, property, valFunc) {
        if(!parent) return;

        if(parent[property] === undefined) {
            return findParentWithProperty(parent.$parent, property, valFunc);
        } else {
            return parent;
    }

  }



// WEBPACK FOOTER //
// ./src/framework/utils/main-plugin.js